/**
 * Script Error Handler
 * Provides robust error handling and fallback mechanisms for third-party scripts
 */

(function () {
  "use strict";

  // Configuration for third-party services
  const SERVICE_CONFIG = {
    klaviyo: {
      name: "Klaviyo",
      url:
        "https://static.klaviyo.com/js/klaviyo.js?company_id=TP89w9&shop=" +
        (window.Shopify && window.Shopify.shop ? window.Shopify.shop : ""),
      shouldLoad: function () {
        return document.querySelector('[data-klaviyo], [class*="klaviyo-form"], form[action*="klaviyo"]') !== null;
      },
      fallback: function () {
        console.warn("Klaviyo unavailable - email marketing features disabled");
        // Create a mock Klaviyo object to prevent errors
        window._learnq = window._learnq || [];
        window.klaviyo = window.klaviyo || {
          push: function () {
            console.log("Klaviyo mock:", arguments);
          },
        };
      },
    },
    trustpilot: {
      name: "Trustpilot",
      url: "https://ecommplugins-scripts.trustpilot.com/js/header.min.js",
      shouldLoad: function () {
        return document.querySelector("[data-trustpilot], .trustpilot-widget") !== null;
      },
      fallback: function () {
        console.warn("Trustpilot unavailable - reviews widget disabled");
        // Hide Trustpilot widgets
        const widgets = document.querySelectorAll(
          "[data-trustpilot], .trustpilot-widget"
        );
        widgets.forEach((widget) => {
          widget.style.display = "none";
          widget.innerHTML =
            '<p style="text-align: center; padding: 1rem; color: #666;">Reviews temporarily unavailable</p>';
        });
      },
    },
    judgeMe: {
      name: "Judge.me",
      url: "https://cdnwidget.judge.me/shopify_v2/leex.js",
      shouldLoad: function () {
        return document.querySelector('.jdgm-widget, [data-judge-me], .jdgm-preview-badge') !== null;
      },
      fallback: function () {
        console.warn("Judge.me unavailable - reviews disabled");
        // Hide Judge.me widgets
        const widgets = document.querySelectorAll(
          "[data-judge-me], .jdgm-widget"
        );
        widgets.forEach((widget) => {
          widget.style.display = "none";
          widget.innerHTML =
            '<p style="text-align: center; padding: 1rem; color: #666;">Reviews temporarily unavailable</p>';
        });
      },
    },
    facebook: {
      name: "Facebook Pixel",
      url: "https://connect.facebook.net/en_US/fbevents.js",
      fallback: function () {
        console.warn("Facebook Pixel unavailable - tracking disabled");
        // Create a mock fbq function
        window.fbq =
          window.fbq ||
          function () {
            console.log("Facebook Pixel mock:", arguments);
          };
      },
      preload: function () {
        // Check if Facebook Pixel is already loaded or initialized
        if (
          window.fbq &&
          (window.fbq._initialized ||
            document.querySelector('script[src*="fbevents.js"]'))
        ) {
          console.log("Facebook Pixel already loaded, skipping duplicate");
          return;
        }

        // Initialize fbq before the script loads to prevent errors
        window.fbq =
          window.fbq ||
          function () {
            console.log("Facebook Pixel preload:", arguments);
          };
        // Mark as initialized to prevent duplicates
        window.fbq._initialized = true;

        // Only initialize if not already done
        if (!window.fbq._initCalled) {
          window.fbq._initCalled = true;
          // Don't call init here - let the actual script handle it
          // window.fbq('track', 'PageView');
        }
      },
      shouldLoad: function () {
        // Don't load if already present
        return !document.querySelector('script[src*="fbevents.js"]');
      },
    },
  };

  // Script loading with retry and error handling
  function loadScriptWithRetry(config, maxRetries = 2) {
    return new Promise((resolve, reject) => {
      if (
        config.shouldLoad &&
        typeof config.shouldLoad === "function" &&
        !config.shouldLoad()
      ) {
        resolve({ skipped: true });
        return;
      }

      let attempts = 0;

      function attemptLoad() {
        attempts++;

        const script = document.createElement("script");
        script.src = config.url;
        script.async = true;
        script.defer = true;

        script.onload = function () {
          console.log(`${config.name} loaded successfully`);
          resolve();
        };

        script.onerror = function () {
          if (attempts < maxRetries) {
            // Exponential backoff
            setTimeout(attemptLoad, Math.pow(2, attempts) * 1000);
          } else {
            console.warn(`${config.name} failed to load after ${maxRetries} attempts`);
            config.fallback();
            reject(new Error(`${config.name} load failed`));
          }
        };

        document.head.appendChild(script);
      }

      attemptLoad();
    });
  }

  // Global error handler for runtime errors
  function setupGlobalErrorHandler() {
    window.addEventListener("error", function (event) {
      const url = event.filename || event.target?.src || "";

      // Handle specific service errors
      Object.keys(SERVICE_CONFIG).forEach((serviceKey) => {
        const service = SERVICE_CONFIG[serviceKey];
        if (url.includes(service.url) || url.includes(serviceKey)) {
          console.warn(`⚠️ ${service.name} runtime error:`, event.message);
          event.preventDefault();
          service.fallback();
          return false;
        }
      });

      // Handle shop.app errors
      if (url.includes("shop.app") || url.includes("/pay/hop")) {
        console.warn("⚠️ Shop.app service error:", event.message);
        event.preventDefault();
        return false;
      }

      // Handle Facebook Pixel duplicate warnings
      if (
        event.message &&
        event.message.includes("Multiple pixels with conflicting versions")
      ) {
        console.warn(
          "⚠️ Facebook Pixel duplicate detected - this is normal if multiple apps use Facebook Pixel"
        );
        event.preventDefault();
        return false;
      }

      // Handle Facebook Pixel duplicate warnings from console.log
      if (
        event.message &&
        event.message.includes("Multiple pixels with conflicting versions")
      ) {
        return false;
      }
    });
  }

  // Enhanced fetch error handling
  function setupFetchErrorHandler() {
    // Removed fetch override to avoid masking analytics and conversion tracking.
    // If specific third‑party fallbacks are needed, handle them where they are used
    // without altering global fetch behaviour.
  }

  // Suppress Shop App beacon 403 errors
  function suppressShopAppBeacon() {
    // Removed sendBeacon override to avoid masking analytics and attribution beacons.
  }

  // Handle Globo filter async promise rejections and initialization
  function setupGloboFilterErrorHandler() {
    // Handle async promise rejections
    window.addEventListener("unhandledrejection", (event) => {
      const msg = event.reason && event.reason.message;
      if (
        msg &&
        msg.includes("Cannot read properties of null") &&
        event.reason.stack &&
        event.reason.stack.includes("globo.filter")
      ) {
        event.preventDefault(); // swallow for Lighthouse
        console.warn("⚠️ Globo filter async error suppressed:", msg);
      }
    });

  }

  // Initialize error handling
  function init() {
    setupGlobalErrorHandler();
    setupFetchErrorHandler();
    suppressShopAppBeacon();
    setupGloboFilterErrorHandler();
    setupPassiveEventListeners();
    suppressFacebookPixelWarnings();
    // Preload critical functions to prevent errors (excluding Facebook - handled by consent gates)
    Object.values(SERVICE_CONFIG).forEach((service) => {
      if (service.name === "Facebook Pixel") {
        console.log(
          `⏭️ Skipping ${service.name} preload - handled by consent gates`
        );
        return;
      }
      if (service.preload && typeof service.preload === "function") {
        service.preload();
      }
    });

    // Load scripts with error handling (excluding restricted services - handled by consent gates)
    Object.values(SERVICE_CONFIG).forEach((service) => {
      // Skip restricted services - they are handled by consent gates
      if (['Facebook Pixel', 'Klaviyo', 'Trustpilot'].includes(service.name)) {
        console.log(`⏭️ Skipping ${service.name} - handled by consent gates`);
        return;
      }

      // Check if service should be loaded
      if (
        service.shouldLoad &&
        typeof service.shouldLoad === "function" &&
        !service.shouldLoad()
      ) {
        console.log(
          `⏭️ Skipping ${service.name} - already loaded by another source`
        );
        return;
      }

      loadScriptWithRetry(service, 2).catch(() => {
        // Error already handled by fallback
      });
    });
  }

  // Suppress Facebook Pixel duplicate warnings
  function suppressFacebookPixelWarnings() {
    // Override console.warn to filter out Facebook Pixel duplicate messages
    const originalWarn = console.warn;
    console.warn = function (...args) {
      const message = args.join(" ");
      if (
        message.includes("Multiple pixels with conflicting versions") ||
        (message.includes("Meta Pixel") &&
          message.includes("conflicting versions"))
      ) {
        // Suppress these warnings as they're expected with multiple apps
        return;
      }
      originalWarn.apply(console, args);
    };
  }

  // Fix passive event listener warnings
  function setupPassiveEventListeners() {
    const originalAddEventListener = EventTarget.prototype.addEventListener;
    EventTarget.prototype.addEventListener = function (
      type,
      listener,
      options
    ) {
      // Make touchstart and touchmove events passive by default for better performance
      if ((type === "touchstart" || type === "touchmove") && !options) {
        options = { passive: true };
      } else if (
        (type === "touchstart" || type === "touchmove") &&
        typeof options === "object"
      ) {
        options.passive = options.passive !== false; // Default to true unless explicitly set to false
      }
      return originalAddEventListener.call(this, type, listener, options);
    };
  }

  // Initialize when DOM is ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  // Expose loaders to consent gates
  window.__pdConsent = window.__pdConsent || {};
  
  function createLoader(serviceName) {
    return function() {
       const config = Object.values(SERVICE_CONFIG).find(s => s.name === serviceName);
       if (config) {
          return loadScriptWithRetry(config, 2).catch((error) => {
            console.warn(`[script-error-handler] ${serviceName} load failed:`, error);
            throw error;
          });
       }
       return Promise.reject(new Error(`${serviceName} config not found`));
    };
  }

  window.__pdConsent.loadMetaPixelScript = createLoader("Facebook Pixel");
  window.__pdConsent.loadKlaviyoScript = createLoader("Klaviyo");
  window.__pdConsent.loadTrustpilotScript = createLoader("Trustpilot");

})();
